module.exports = __webpack_public_path__ + "img/zoom-addin-thumbnail.73408abb.png";